import { render } from "./FlowNodeNote.vue?vue&type=template&id=a43529f6&scoped=true&ts=true"
import script from "./FlowNodeNote.vue?vue&type=script&lang=ts"
export * from "./FlowNodeNote.vue?vue&type=script&lang=ts"

import "./FlowNodeNote.vue?vue&type=style&index=0&id=a43529f6&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43529f6"]])

export default __exports__